import { BalanceDisplay, DeltaLabel } from '@/shared/components';
import type { BaseAsset } from '@/shared/types';
import { useTranslation } from 'react-i18next';

type Props = {
  isBalancesHidden: boolean;
  balance: number | null;
  deltaPercent: number | null;
  currency: BaseAsset;
  precision: number;
  isPending: boolean | undefined;
};

export const AccountBalance = ({
  isBalancesHidden,
  balance,
  deltaPercent,
  currency,
  precision,
  isPending,
}: Props) => {
  const { t } = useTranslation();
  if (isPending)
    return (
      <div className="p5 text-secondary dots-animation">
        {t('openAccount.pending')}
      </div>
    );
  if (balance == null) return null;
  return (
    <div className="flex items-end gap-[1rem]">
      <BalanceDisplay
        isBalancesHidden={isBalancesHidden}
        balance={balance}
        precision={precision}
        currency={currency}
        size="small"
      />
      {balance < 1000000000 && (
        <DeltaLabel
          deltaPercent={deltaPercent}
          size="small"
          showLabelText={false}
          className="bg-transparent p-0"
        />
      )}
    </div>
  );
};
